module.exports = __webpack_public_path__ + "static/media/icon-menu-edit.a8e41ec5.svg";